import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './footer.css';

const Footer = () => {
    return (
        <footer className="footer bg-dark text-light">
            <Container className="py-5">
                <Row className="g-4">
                    {/* Company Info */}
                    <Col lg={4} md={12} className="mb-4">
                        <div className="footer-brand">
                            <img src={require('./pasada1.png')} alt="PASADA LOGO" className="footer-logo mb-4"/>
                            <h3 className="brand-name text-light mb-3">PASADA</h3>
                            <p className="brand-tagline mb-4">The Next Generation of Public Transportation.</p>
                            <p className="footer-description">
                                Revolutionizing modern jeepney and bus transportation in the Philippines through 
                                innovative technology, IoT solutions, and data-driven insights for safer, smarter mobility.
                            </p>
                            
                            {/* Social Media */}
                            <div className="social-media mt-4">
                                <h6 className="social-title mb-3">Follow Us</h6>
                                <div className="social-links">
                                    <a href="https://www.facebook.com/fastracPASADA" className="social-link facebook" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                                        <i className="fab fa-facebook-f"></i>
                                        <span className="icon-fallback">f</span>
                                    </a>
                                    <a href="https://www.linkedin.com/company/108375353/" className="social-link linkedin" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                                        <i className="fab fa-linkedin-in"></i>
                                        <span className="icon-fallback">in</span>
                                    </a>
                                    <a href="https://www.youtube.com/watch?v=AN7ht86bj2I" className="social-link youtube" aria-label="YouTube" target="_blank" rel="noopener noreferrer">
                                        <i className="fab fa-youtube"></i>
                                        <span className="icon-fallback">▶</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>

                    {/* Navigation Columns */}
                    <Col lg={8} md={12}>
                        <Row className="g-4">
                            {/* Quick Links */}
                            <Col lg={4} md={4} sm={6} className="mb-4">
                                <div className="footer-section">
                                    <h5 className="section-title">Quick Links</h5>
                                    <ul className="footer-nav">
                                        <li><a href="/" className="nav-link">Home</a></li>
                                        <li><a href="/about" className="nav-link">About Us</a></li>
                                        <li><a href="/products" className="nav-link">Products</a></li>
                                        <li><a href="/projects" className="nav-link">Projects</a></li>
                                        <li><a href="/blogs" className="nav-link">Insights & Stories</a></li>
                                        <li><a href="/contact" className="nav-link">Contact Us</a></li>
                                    </ul>
                                </div>
                            </Col>

                            {/* Solutions */}
                            <Col lg={4} md={4} sm={6} className="mb-4">
                                <div className="footer-section">
                                    <h5 className="section-title">Solutions</h5>
                                    <ul className="footer-nav">
                                        <li><a href="/solution" className="nav-link">PASADA System</a></li>
                                        <li><a href="#" className="nav-link">IoT Monitoring</a></li>
                                        <li><a href="#" className="nav-link">Driver Training</a></li>
                                        <li><a href="#" className="nav-link">Data Analytics</a></li>
                                        <li><a href="#" className="nav-link">Safety Systems</a></li>
                                    </ul>
                                </div>
                            </Col>

                            {/* Contact & Newsletter */}
                            <Col lg={4} md={4} sm={12} className="mb-4">
                                <div className="footer-section">
                                    <h5 className="section-title">Contact Information</h5>
                                    <div className="contact-details mb-4">
                                        <div className="contact-item">
                                            <i className="fas fa-map-marker-alt"></i>
                                            <span> 938 Aurora Blvd.<br/>Cubao, Quezon City 1109<br/>Philippines</span>
                                        </div>
                                        <div className="contact-item">
                                            <i className="fas fa-phone"></i>
                                            <span>(+632) 8911-0964 ext. 312</span>
                                        </div>
                                        <div className="contact-item">
                                            <i className="fas fa-envelope"></i>
                                            <span>fastrac.pasada@tip.edu.ph</span>
                                        </div>
                                        <div className="contact-item">
                                            <i className="fas fa-clock"></i>
                                            <span>Mon - Fri: 8:00 AM - 5:00 PM</span>
                                        </div>
                                    </div>
                                    
                                    {/* Newsletter */}
                                    <div className="newsletter-section">
                                        <h6 className="newsletter-title">Stay Updated</h6>
                                        <p className="newsletter-desc">Get the latest news and updates from PASADA</p>
                                        <div className="newsletter-form">
                                            <input 
                                                type="email" 
                                                className="email-input" 
                                                placeholder="Enter your email"
                                                aria-label="Email address"
                                            />
                                            <button className="subscribe-btn" type="button">
                                                Subscribe
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
            
            {/* Footer Bottom */}
            <div className="footer-bottom">
                <Container>
                    <Row className="align-items-center py-4">
                        <Col md={12} className="text-center">
                            <div className="copyright-section-inline">
                                <span className="copyright-text">© 2025 PASADA Philippines. All Rights Reserved.</span>
                                <span className="separator-main">•</span>
                                <div className="legal-links-inline">
                                    <a href="#" className="legal-link">Privacy Policy</a>
                                    <span className="separator">•</span>
                                    <a href="#" className="legal-link">Terms of Service</a>
                                    <span className="separator">•</span>
                                    <a href="#" className="legal-link">Sitemap</a>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </footer>
    );
}

export default Footer;